import React, {Fragment, useEffect, useState} from 'react';
import {connect} from "react-redux"

import UserDocTableV3 from "./UserDocTableV3";
import FormStock from "./FomrsStock";
import Activity from "./Activity";

import UserPrefs from "./UserPrefs";
import ShopBase from "../shop/ShopBase";
import CommandeProduct from "../shop/payement/CommandeProduct";
import InvoicesBase from "../shop/invoices/InvoicesBase";
import OrdersBase from "../shop/orders/OrdersBase";
import Subscription from "./Subscription";
import FormDetail from "./FormDetail";
import FormsStates from "./FormsStates";
import Parameters from "./Parameters";
import Compte from "./Compte";
import PricingPanel from "./PricingPanel";
import DocumentOrdersTable from './DocumentOrdersTable';

import Styles from "./Dashboard.scss";
import ContactPanel from "./ContactPanel";


const Dashboard = (props) => {

    const [forms, setForms] = useState([])
    useEffect(()=>{
        //fetchUserData();
        checkCurrentUrl();
        console.log("Dashboard", props.entity.genre.slug);
    }, [])

    useEffect(()=>{
        //(props.checkForms)?getUserFormeRef():null;
        //console.log("data forms !!", props.checkForms);
    }, [props.checkForms])

    useEffect(()=>{
        if(props.currentPage==='pricing'){
            props.setShowPricing(true)
            props.setCurrentCenterPage('dashboard')
        }

    },[props.currentPage])

    const fetchUserData = ()=>{
        //getUserFormeRef()
    }


    const checkCurrentUrl = ()=>{
        let currentLocation = (window.location).pathname.split('/');
        switch(currentLocation[currentLocation.length-1]){
            case 'produits':
                props.navigateTo('product')
                break;
            default:
                return;
        }
    }

    return (<>
        <div id={"dashboard"} className={"w-100 h-100 fixed-top "} style={{"paddingTop":"44px","paddingBottom":"28px"}}  >
                <div className={"d-flex flex-row justify-content-between ue-bg w-100"} >
                    <div id={"ue-dashboard-navlinks"} className={"ue-dashboard-nav d-flex flex-row align-content-end w-100 "} >
                        <div
                            onClick={(e)=>{props.setCurrentCenterPage("dashboard")}}
                            className={`ue-dashboard-nav-item  ${(props.currentPage==='dashboard' || props.currentPage==='dossiers' +
                                '')?"active":""}`}>
                            <a className="nav-link ue-dashboard-nav-link" href="#">Formulaires</a>
                        </div>
                        <div
                            onClick={(e)=>{props.setCurrentCenterPage("compte")}}
                            className={`ue-dashboard-nav-item  ${props.currentPage==='compte' ? "active" : ""}`}>
                            <a className="nav-link ue-dashboard-nav-link" href="#">Compte</a>
                        </div>
                        <div
                            onClick={(e)=>{props.setCurrentCenterPage("parameters")}}
                            className={`ue-dashboard-nav-item  ${props.currentPage==='parameters' ? "active" : ""}`}>
                            <a className="nav-link ue-dashboard-nav-link" href="#">Paramètres</a>
                        </div>
                        <div
                            onClick={(e)=>{props.setCurrentCenterPage("subscription")}}
                            className={`ue-dashboard-nav-item  ${props.currentPage==='subscription' ? "active" : ""}`}>
                            <a className="nav-link ue-dashboard-nav-link" href="#">Factures</a>
                        </div>
                        {/*<div
                            onClick={(e)=>{props.setCurrentCenterPage("order")}}
                            className={`ue-dashboard-nav-item  ${props.currentPage==='order' ? "active" : ""}`}>
                            <a className="nav-link ue-dashboard-nav-link" href="#">Commandes</a>
                        </div>*/}
                        {/*<div
                            onClick={(e)=>{props.setCurrentCenterPage("pricing")}}
                            className={`ue-dashboard-nav-item  ${props.currentPage==='pricing' ? "active" : ""}`}>
                            <a className="nav-link ue-dashboard-nav-link" href="#">Tarifs</a>
                        </div>*/}

                        <div
                            onClick={(e)=>{props.setCurrentCenterPage("contact")}}
                            className={`ue-dashboard-nav-item  ${props.currentPage==='contact' ? "active" : ""}`}>
                            <a className="nav-link ue-dashboard-nav-link " href="#">Contact</a>
                        </div>
                        {/* {(props?.role &&  props.role === 'admin')?
                            <div
                                onClick={(e) => {
                                    window.open('/admin', '_self')
                                }}
                                className={`ue-dashboard-nav-item rounded-top ${props.currentPage === 'admin' ? "active" : ""}`}>
                                <a className="nav-link ue-dashboard-nav-link " href="#">Admin</a>
                            </div>
                            :null
                        } */}

                    </div>
                </div>
                <div className={"d-flex flex-col flex-md-row w-100 h-100"} >
                    {(props.currentPage === 'dossiers' || props.currentPage === 'dashboard') && (
                        <div className="d-flex flex-column align-items-center w-100 text-black ue-dashboard-render-zone-wrapper">
                            {props?.entity?.genre?.slug === 'collective' ? (
                                <>
                                    <FormsStates vals={forms} />
                                    <UserDocTableV3 forms={setForms} />
                                </>
                            ): <DocumentOrdersTable />}
                        </div>
                    )}

                    {(props.currentPage === 'userprefs') ?
                        <div id={'dashboard_userprefs'} className="d-flex flex-column align-items-center w-100 text-black ue-dashboard-render-zone-wrapper">
                            <UserPrefs />
                        </div>
                        : null
                    }
                    {(props.currentPage === 'compte') ?
                        <div id={'dashboard_parameters'} className="d-flex flex-column align-items-center w-100 text-black ue-dashboard-render-zone-wrapper">
                            <Compte />
                        </div>
                        : null
                    }
                    {(props.currentPage === 'parameters') ?
                        <div id={'dashboard_parameters'} className="d-flex flex-column align-items-center w-100 text-black ue-dashboard-render-zone-wrapper">
                            <Parameters />
                        </div>
                        :null
                    }
                    {(props.currentPage==='contact')?
                        <ContactPanel />
                        :null
                    }
                    {(props.currentPage==='product')?
                        <ShopBase />
                        :null
                    }
                    {(props.currentPage==='invoices')?
                        <InvoicesBase />
                        :null
                    }
                    {/*{(props.currentPage==='pricing')?
                        <PricingPanel />
                        :null
                    }*/}
                    {(props.currentPage==='subscription')?
                        <div id={'dashboard_subscriptions'} className="d-flex flex-column align-items-center w-100 text-black ue-dashboard-render-zone-wrapper">
                        <Subscription />
                        </div>
                        :null
                    }
                    {(props.currentPage==='orders')?
                        <OrdersBase />
                        :null
                    }
                    {
                        (props.currentPage==='commandProduct')?
                            <CommandeProduct />
                            :null
                    }
                    {
                        (props.currentPage==='formDetail')?
                            <FormDetail />
                            :null
                    }
                </div>
            </div>
    </>


    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        entity: state.MeReducer.entity,
        username : state.MeReducer.username,
        role : state.MeReducer.role,
        currentPage: state.DashboardReducer.current_page,
        checkForms: state.DashboardReducer.checkForms,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        navigateTo : (e)=> dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        setCurrentCenterPage: (e) => dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        showCenterSection: (e) => dispatch( {type: 'SHOW_CENTER_SECTION', data:e}),
        setCheckForm: (e) => dispatch({type: 'SET_CHECK_FORMS', data: e}),
        setShowPricing : (e)=>dispatch({type: 'SET_SHOW_PRICING', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(Dashboard);
